// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { call, put, takeLatest } from 'redux-saga/effects';
import UserInfoDal from './../../../dal/UserInfoDal';
import {
    getUserInfoData,
    getUserInfoDataFail,
    getUserInfoDataRequest,
    getUserInfoDataSuccess,
    setUserTierData,
    setUserTierDataFail,
    setUserTierDataRequest,
    setUserTierDataSuccess,
} from './../../../store/user/userInfoReducer';

function* fetchUserInfo(): IterableIterator<any> {
    try {
        yield put(getUserInfoDataRequest());
        const response = yield call(UserInfoDal.getUserInfo);
        if (response && Object.keys(response).length > 0) {
            const {email,tierName,soldToCustomerNbr,shiptoCustomerNbr} = response;
            sessionStorage.setItem("loggedInuserInfo",JSON.stringify({email,tierName,soldToCustomerNbr,shiptoCustomerNbr}));                
        } 
        yield put(getUserInfoDataSuccess(response));
    } catch (e) {
        yield put(getUserInfoDataFail(e));
    }
}

function* setUserInfo(param: any): IterableIterator<any> {
    try {
        yield put(setUserTierDataRequest());
        yield put(setUserTierDataSuccess(param.payload));
    } catch (e) {
        yield put(setUserTierDataFail(e));
    }
}

export default [
    takeLatest(`${getUserInfoData}`, fetchUserInfo),
    takeLatest(`${setUserTierData}`, setUserInfo),
];
